import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 5H17.25C17.7141 5 18.1592 5.1873 18.4874 5.5207C18.8156 5.8541 19 6.30628 19 6.77778V9.5M8 5H6.75C6.28587 5 5.84075 5.1873 5.51256 5.5207C5.18437 5.8541 5 6.30628 5 6.77778V19.2222C5 19.6937 5.18437 20.1459 5.51256 20.4793C5.84075 20.8127 6.28587 21 6.75 21H17.25C17.7141 21 18.1592 20.8127 18.4874 20.4793C18.8156 20.1459 19 19.6937 19 19.2222V16.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 3H9C8.44772 3 8 3.33579 8 3.75V5.25C8 5.66421 8.44772 6 9 6H15C15.5523 6 16 5.66421 16 5.25V3.75C16 3.33579 15.5523 3 15 3Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="17" cy="13" r="4" />
    <path
      d="M19 12L16.6186 14.5979C16.4204 14.8141 16.0796 14.8141 15.8814 14.5979L15 13.6364"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
